import React, { ForwardedRef, forwardRef, memo } from 'react'
import { TextField, TextFieldProps } from '@mui/material'

export interface ThemedMUITextFieldProps extends Omit<TextFieldProps, 'classes'> {}

function ThemedMUITextField(props: TextFieldProps, ref: ForwardedRef<HTMLDivElement>) {
  const { InputProps, ...restProps } = props

  return (
    <TextField
      {...restProps}
      ref={ref}
      InputProps={{
        ...(InputProps || {}),
      }}
    />
  )
}

export default memo(forwardRef(ThemedMUITextField))
